import React, { useRef } from 'react';
import { useSpring, animated } from '@react-spring/web';

const GrassBlade = ({ offset, opacity, duration }) => {
    const pathRef = useRef(null);

    const { t } = useSpring({
        from: { t: 0 },
        to: { t: 2 * Math.PI },
        config: { duration: duration },
        loop: { reverse: true },
    });

    return (
        <animated.path
            ref={pathRef}
            d={t.to(t => {
                const startPoint = { x: 100 + 15 * Math.sin((t + offset) / 1.5), y: 150 };
                const controlPoint1 = { x: 100 + 5 * Math.sin(t + offset), y: 120 + 5 * Math.cos((t + offset) / 2) };
                const controlPoint2 = { x: 110 + 10 * Math.sin((t + offset) / 2), y: 90 + 5 * Math.cos((t + offset) / 1.5) };
                const endPoint = { x: 120 + 15 * Math.sin((t + offset) / 1.5), y: 50 };
                return `M${startPoint.x},${startPoint.y} C${controlPoint1.x},${controlPoint1.y} ${controlPoint2.x},${controlPoint2.y} ${endPoint.x},${endPoint.y}`;
            })}
            stroke="#456837"
            strokeWidth="10"
            fill="none"
            style={{ opacity }}
        />
    );
};

export default GrassBlade;
